import { Component, Input, Inject, OnInit } from '@angular/core';
import { ActivityTypeDataService } from "../../core/activitytypes.dataservice";
import { SummationGroupDataService } from "../../core/summationgroups.dataservice";

@Component({
    selector: "summation-group-mappings",
    template: require('./summation-group-mappings.component.html')
})
export class SummationGroupMappings implements OnInit {
    private activityTypes: Nema.Crew.Model.ActivityType[];

    constructor(
        @Inject(SummationGroupDataService.Id) private summationGroupDataService: SummationGroupDataService,
        @Inject(ActivityTypeDataService.Id) private activityTypeDataService: ActivityTypeDataService) {

        // default values
        this.isReadonly = false;
    }

    ngOnInit() {
        this.activityTypeDataService
            .getAll()
            .then(res => this.activityTypes = res);
    }

    @Input()
    summationGroup: Nema.Crew.Model.ActivityTypeSummationGroup;

    @Input()
    isReadonly: boolean;
    
    public addMapping(): void {
        var newMapping = this.summationGroupDataService.newSummationGroupMapping(this.activityTypes[0].Id);
        this.summationGroup.ActivityTypeSummationGroupMapping.push(<any>newMapping);
    }

    public removeMapping(step: Nema.Crew.Model.ActivityTypeSummationGroupMapping): void {
        var index = this.summationGroup.ActivityTypeSummationGroupMapping.indexOf(step, 0);
        if (index > -1) {
            var mappingToDelete = this.summationGroup.ActivityTypeSummationGroupMapping[index];
            this.summationGroupDataService.removeMapping(mappingToDelete, () => this.summationGroup.ActivityTypeSummationGroupMapping.splice(index, 1));
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/summationgroups/summation-group-mappings.component.ts